import type { HalebopConfirmOrderRequest } from '~/models/checkout/ConfirmOrderRequest.api.model';
import FetchFactory from '../factory';
import type { ShippingMethod } from './ShippingMethod.module';

const CONTROLLER_PATH_NOP = '/api-frontend/Checkout/';
const CONTROLLER_PATH_ELECTRA = '/api-electra/Checkout/';

export interface ConfirmOrderResponse {
  Id: number;
  OrderGuid: string;
  RedirectToMethod: string;
}

class CheckoutModule extends FetchFactory<any> {
  async setDeliveryMethod(shippingMethod: ShippingMethod) {
    const param = `${shippingMethod.Name}___${shippingMethod.ShippingMethodSystemName}`;
    const url = `${CONTROLLER_PATH_NOP}SelectShippingMethod?shippingOption=${param}`;
    return await this.call('POST', url, {});
  }

  async confirmOrder(
    payload: HalebopConfirmOrderRequest,
  ): Promise<ConfirmOrderResponse> {
    const url = `${CONTROLLER_PATH_ELECTRA}ConfirmOrder`;
    return await this.post(url, payload).then((response) => {
      return response;
    });
  }
}

export default CheckoutModule;
